// extracted by mini-css-extract-plugin
export default {"titleTerm":"Term_titleTerm__H9ROx","parTerm":"Term_parTerm__oHBWo","termsBtn":"Term_termsBtn__2wLa8","privacyText":"Term_privacyText__rAVTv"};